import React from 'react';
import { UserCircle, UserRectangle } from '@phosphor-icons/react';
import { Upload } from 'antd';
import type { UploadFile } from 'antd/es/upload/interface';
import classNames from 'classnames';
import { isMobile, isTablet } from 'react-device-detect';

import { isEmpty } from '../../utils';

interface Props {
  id?: string;
  type: 'video' | 'image';
  heading?: string;
  isMultiple?: boolean;
  isDashboard?: boolean;
  imgUrl?: string;
  onDrop: (file: any, fileList: any) => void;
  isPreview?: boolean;
}

const DraggerSimplified: React.FC<Props> = (props) => {
  const {
    id,
    type,
    heading,
    isMultiple,
    isDashboard,
    imgUrl,
    onDrop,
    isPreview,
  } = props;

  const beforeUpload = (file: UploadFile, fileList: UploadFile[]) => {
    onDrop(file, fileList);
    return false;
  };

  let draggerProps: any = { id, name: 'file', showUploadList: false };

  if (type === 'video') draggerProps = { ...draggerProps, accept: '.mov,.mp4' };
  else if (type === 'image')
    draggerProps = { ...draggerProps, accept: '.bmp,.gif,.jpeg,.jpg,.png' };

  if (isMultiple) draggerProps = { ...draggerProps, multiple: true };
  else draggerProps = { ...draggerProps, maxCount: 1, multiple: false };

  const Icon = type === 'video' ? UserRectangle : UserCircle;

  const imageClass = classNames({
    'object-cover': true,
    'rounded-full w-24 h-24 sm:w-32 sm:h-32': !isDashboard,
    'rounded-md max-w-[90%] sm:max-w-[50%] max-h-40': isDashboard,
  });

  return (
    <Upload.Dragger
      {...draggerProps}
      className="group shadow-xl"
      beforeUpload={(file, fileList) => beforeUpload(file, fileList)}
    >
      <div className="min-h-40 h-auto sm:h-40 flex flex-col sm:flex-row items-center justify-center gap-4 px-4 text-base text-center sm:text-left">
        {imgUrl ? (
          <img className={imageClass} src={imgUrl} alt="Uploaded Graphic" />
        ) : (
          <Icon
            weight="fill"
            className="fill-[url('#icon-primary-gradient')] group-hover:animate-pulsing"
            size={100}
          />
        )}

        <div>
          {heading && <div className="font-bold">{heading}</div>}

          <div className={heading ? '' : 'font-bold'}>
            {isMobile || isTablet || isPreview
              ? 'Click to upload'
              : 'Drag and drop or click to upload'}
          </div>

          {!isEmpty(imgUrl) && (
            <div className="text-sm italic">
              Note: This will replace the current image
            </div>
          )}
        </div>
      </div>
    </Upload.Dragger>
  );
};

export default DraggerSimplified;
